import { ZoomNotStartedWarning } from '@/components/session/zoom-not-started-warning.js';
import { Badge } from '@/components/ui/badge.js';
import { MeetingStatus, MeetingStatusLabelMap } from '@airreading/common/data';
import clsx from 'clsx';

interface MeetingStatusBadgeProps {
  status: MeetingStatus | null;
  zoomNotStarted?: boolean;
  'data-testid'?: string;
  warningTestId?: string;
}

const MeetingStatusColorMap: Record<MeetingStatus, string> = {
  [MeetingStatus.waiting]: 'bg-orange-600',
  [MeetingStatus.started]: 'bg-green-600',
  [MeetingStatus.ended]: 'bg-slate-600',
  [MeetingStatus.canceled]: 'bg-slate-600',
};

export function MeetingStatusBadge({
  status,
  zoomNotStarted,
  'data-testid': dataTestId,
  warningTestId,
}: MeetingStatusBadgeProps) {
  if (!status) {
    return null;
  }

  const colorClass = MeetingStatusColorMap[status];
  const label = MeetingStatusLabelMap[status];

  const badge = (
    <Badge className={clsx(colorClass)} data-testid={dataTestId}>
      {label}
    </Badge>
  );

  if (!zoomNotStarted) {
    return badge;
  }

  return (
    <div className="flex items-center gap-1 whitespace-nowrap">
      {badge}
      <ZoomNotStartedWarning data-testid={warningTestId} />
    </div>
  );
}
